/**
 * SkillDelivery Platform
 *
 * Copyright © 2026 SKD RATWANI Technology & Software Solutions Pvt Ltd
 * All Rights Reserved.
 *
 * PROPRIETARY AND CONFIDENTIAL
 *
 * Sitewide footer for PUBLIC pages only (welcome, manifesto, tour,
 * entity landings, domain pages, SkillCode/Cricket marketing pages).
 * Not rendered inside the authenticated app chrome.
 */

import React from 'react';
import { Link } from 'react-router-dom';

const PublicFooter = () => {
  return (
    <footer className="relative border-t border-brand-border bg-white/60 backdrop-blur-sm mt-16">
      <div className="max-w-6xl mx-auto px-6 py-10 text-center">

        {/* Vision tagline */}
        <p className="text-sm sm:text-base text-brand-text2 leading-relaxed max-w-2xl mx-auto">
          Where expertise becomes visible —{' '}
          <span className="text-brand-muted">
            practitioners, teams, universities, institutes.
          </span>
        </p>

        {/* Link row */}
        <nav
          aria-label="Footer"
          className="mt-5 flex flex-wrap justify-center items-center gap-x-5 gap-y-2 text-sm"
        >
          <span className="text-brand-cyan font-semibold italic">
            Skills, Delivered!
          </span>
          <span aria-hidden="true" className="text-brand-border">·</span>
          <Link
            to="/manifesto"
            className="text-brand-muted hover:text-brand-cyan font-medium transition-colors"
          >
            Manifesto
          </Link>
          <span aria-hidden="true" className="text-brand-border">·</span>
          <Link
            to="/tour"
            className="text-brand-muted hover:text-brand-cyan font-medium transition-colors"
          >
            Tour
          </Link>
          <span aria-hidden="true" className="text-brand-border">·</span>
          <a
            href="mailto:info@skilldelivery.co.in"
            className="text-brand-muted hover:text-brand-cyan font-medium transition-colors"
          >
            Contact
          </a>
        </nav>

        {/* Copyright */}
        <p className="mt-6 text-xs text-brand-muted2">
          © 2026 SKD RATWANI Technology &amp; Software Solutions
        </p>
      </div>
    </footer>
  );
};

export default PublicFooter;
